/**
 * Referral codes carried by invite links (/signup?ref=CODE).
 *
 * One signup field takes every kind of code: a customer's or provider's
 * referral code, or a Channel Partner code (`CP-` + 8 letters/digits). The
 * backend decides which it is, so this only normalises the shape — uppercase,
 * letters/digits/hyphens, at most 20 characters — and drops anything
 * malformed so garbage is never prefilled.
 */
const MAX_LENGTH = 20;

/** The first code-like value among `?ref=` and the aliases people paste. */
export function referralCodeFromSearch(search: Record<string, unknown>): string | undefined {
  const raw = search.ref ?? search.referral ?? search.code ?? search.referral_code;
  if (typeof raw !== 'string') return undefined;
  const code = raw.trim().toUpperCase().slice(0, MAX_LENGTH);
  return /^[A-Z0-9]+(-[A-Z0-9]+)*$/.test(code) ? code : undefined;
}
